import { render, staticRenderFns } from "./ServerDataWrapper.vue?vue&type=template&id=7792eed8&lang=pug&"
import script from "./ServerDataWrapper.vue?vue&type=script&lang=js&"
export * from "./ServerDataWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Intersect from 'vuetify/lib/directives/intersect'
installDirectives(component, {Intersect})
